import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Last line of defence: a rendering error anywhere shows a recoverable message instead of a
 * blank page. Class component (React has no hook for this), so it reads the interface
 * language from <html lang> rather than the i18n context.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled UI error", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const ar = document.documentElement.lang === "ar";
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "70vh", padding: 20 }}>
        <div className="card stack" style={{ maxWidth: 420 }} role="alert">
          <h1 style={{ margin: 0, fontSize: 20 }}>{ar ? "حدث خطأ ما" : "Something went wrong"}</h1>
          <p className="muted" style={{ margin: 0 }}>
            {ar
              ? "واجهت الصفحة مشكلة غير متوقعة. لم يتم فقدان أي قرارات مسجّلة."
              : "This page hit an unexpected problem. Decisions you already recorded are not lost."}
          </p>
          <div className="row">
            <button className="btn primary" onClick={() => window.location.reload()}>
              {ar ? "إعادة التحميل" : "Reload"}
            </button>
            <button className="btn" onClick={() => { window.location.hash = "#/"; window.location.reload(); }}>
              {ar ? "العودة إلى المرضى" : "Back to patients"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
